var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 50,
    viewBox: "0 0 75 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.75H12V6.25V40.625V41.125H12.5H43.25V49.5H0.5V41.125H6.25H6.75V40.625V6.25C6.75 3.08864 9.33864 0.5 12.5 0.5H68.25V5.75H12.5ZM68.75 41.125H69.25V40.625V18.75V18.25H68.75H56.25H55.75V18.75V40.625V41.125H56.25H68.75ZM53.125 13H71.875C73.3176 13 74.5 14.1824 74.5 15.625V46.875C74.5 48.3176 73.3176 49.5 71.875 49.5H53.125C51.6824 49.5 50.5 48.3176 50.5 46.875V15.625C50.5 14.1824 51.6824 13 53.125 13Z",
    fill: "current",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputers);
export default __webpack_public_path__ + "static/media/computers.7936a90bfbb48aa12ba4aed946f344b3.svg";
export { ForwardRef as ReactComponent };